import { useUserStore } from 'src/stores/user/user.store';

import { useAuthStore } from './auth.store';

export const useAuth = () => {
  const { accessToken, refreshToken, setIsAuthenticated, clearSession } = useAuthStore();
  const { userData, myBalance, getUserPointsNotifications } = useUserStore()

  const initializeAuth = () => {
    if (accessToken && refreshToken) {
      userData().then(() => {
        setIsAuthenticated(false);
        myBalance();
        getUserPointsNotifications()
      }).catch(() => {
        setIsAuthenticated(false);
        clearSession();
      })
    } else {
      setIsAuthenticated(false);
      clearSession();
    }
  };

  const useAuthHook: any = {
    initializeAuth,
  };

  return useAuthHook;
};
